import Vue from 'vue';
import Vuex from 'vuex';
import assign from 'lodash/assign';

import { SdkStore } from '@nsftx/games-sdk-js/';
// eslint-disable-next-line
import storeConfig from './storeConfig';

Vue.use(Vuex);

export default new Vuex.Store(assign(storeConfig, {
  modules: SdkStore.modules,
}));
